<script lang="ts">
import type { Temporal } from 'temporal-polyfill';
import type { DisplayBlockProps } from '~/types/display-block';
import { supportedTimeFieldTypes } from '#layers/blocks/blocks/Input/InputTime.block.vue';

interface DisplayFormattedTimeProps extends DisplayBlockProps<Temporal.PlainTime> {
	format?: 'short' | 'medium' | 'long' | 'full';
}

const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_formatted_time.name',
	description: '$t:blocks.display_formatted_time.description',
	icon: 'lucide:clock',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: supportedTimeFieldTypes,
	},

	options: [
		{
			name: 'value',
		},
		{
			name: 'format',
			type: 'enum',
			values: ['short', 'medium', 'long', 'full'],
		},
	],
}</script>

<script setup lang="ts">
import { computed } from 'vue';
import { isNil } from '#layers/base';
import { defineBlock } from '#layers/block-engine';

const props = withDefaults(defineProps<DisplayFormattedTimeProps>(), {
	format: 'short',
});

;

const formattedTime = computed(() => props.value?.toLocaleString(undefined, {
	timeStyle: props.format,
}));
</script>

<template>
	<DDisplayValueEmpty v-if="isNil(value)" />
	<div v-else>
		{{ formattedTime }}
	</div>
</template>
